import React from 'react';

const Category = () => {
    return (
        <div>
            <h2>This is Category</h2>
        </div>
    );
};

export default Category;